import Notiflix from 'notiflix';

Notiflix.Loading.init({
  backgroundColor: 'rgba(0,0,0,0.2)',
  svgColor: 'var(--accent-primary)',
  clickToClose: true,
  // cssAnimationDuration: 100,
  svgSize: '100px',
  messageFontSize: '1rem',
  messageColor: 'var(--text-color)',
});
